module.exports = __webpack_public_path__ + "img/levels-of-detail.de.c0d591a9.png";